/**
 * Authored content for a public city guide (`/page/<slug>`).
 *
 * These types live together because they are one contract: what an admin (or the
 * noko MCP) writes, what `updateCityPageSchema` validates on the way in, and
 * what the public payload serves on the way out. No event data belongs here —
 * only guide copy and cited facts.
 */
/**
 * Every illustrated slot there is, at runtime — the closed set above as a value.
 * One list: the authoring schema, the payload decoder and the section registry
 * all read it, so a slot cannot be authorable in one place and unknown in another.
 */
export const CITY_GUIDE_IMAGE_SLOTS = ["history"];
/**
 * The shared guide template's role: the row that holds the default composition
 * every city inherits. One row per role, the way the picks templates work — a
 * guide has exactly one, and its revision is half of what a rendered document is
 * made of.
 */
export const CITY_GUIDE_TEMPLATE_ROLE = "city_guide_default";
//# sourceMappingURL=city-page.js.map